import React from 'react'
import { Route, Switch } from 'react-router-dom'

import TokenHandler from './tokenHandler'
import QRHandler from './qrHandler'

export default (props) => (
	<Switch>
		<Route path="/home/token" exact component={TokenHandler} />
		<Route path="/home/qr" exact component={QRHandler} />
		<Route component={TokenHandler} />
	</Switch>
)


// WEBPACK FOOTER //
// ./src/components/home/Home.jsx